import { FC } from 'react';
import Link from 'next/link';
import Layout from '@/components/layout/Layout';
import Alphabet from '@/components/ui/alphabet/Alphabet';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { ISearchAuthor } from '@/interfaces/authorsPage.interface';
import { getAlphabet } from '@/helpers/helpers';
import styles from './Authors.module.scss';
import { AUTHORS_FOR_PAGE } from '@/helpers/variables';
import Pagination from '@/components/ui/pagination/Pagination';

interface IAuthorsProps {
  data: ISearchAuthor;
  letterSign: string;
}

const Authors: FC<IAuthorsProps> = ({ data, letterSign }) => {
  const pagesCount = Math.ceil(data?.total_count / AUTHORS_FOR_PAGE);

  const letter = getAlphabet(letterSign);
  const pageUrl = useGetUrlPath();
  //Seo block
  const SEO_TITLE = letter.length > 0 ? `Книги на букву ${letter} - список авторов и книг по алфавиту` : 'Электронная библиотека книг фентези и фантастики Fantasy Worlds';
  const SEO_DESCRIPTION =
    letter.length > 0
      ? `Список авторов и книг, названия которых начинаются на букву «${letter}». ▶ Вы можете скачать бесплатно или читать онлайн самые лучшие электронные книги в форматах pdf, epub, fb2, txt.`
      : '🕮 Электронная библиотека книг фентези и фантастики 📚 — Fantasy Worlds. ▶ Вы можете скачать бесплатно или читать онлайн самые лучшие электронные книги в форматах pdf, epub, fb2, txt.';
  const SEO_CANONICAL = pageUrl;

  //Сортировка по фамилии
  const sortedData = data.data.sort(function (a, b) {
    if (a.last_name[1]?.toLowerCase() > b.last_name[1]?.toLowerCase()) {
      return 1;
    }
    if (a.last_name[1]?.toLowerCase() < b.last_name[1]?.toLowerCase()) {
      return -1;
    }
    return 0;
  });

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={pageUrl}>
      <Alphabet letterSign={letter} baseUrl="/lib/letter/" />
      {letter && <SectionTitle name={`Книги на букву ${letter}`} />}
      <div className={styles.authors_wrap}>
        {sortedData &&
          sortedData.length > 0 &&
          sortedData.map((author) => (
            <Link prefetch={false} className={styles.authors} key={author.id} href={`/author/id${author.id}`}>
              {String(author.last_name)} {String(author.first_name)}
            </Link>
          ))}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/letter/${letterSign}/`} />
    </Layout>
  );
};

export default Authors;
